(function(Drupal, once) {

  Drupal.behaviors.triggerClick = {
    attach(context) {
      once('button-click', '.toggle').forEach(
        el => {
          el.addEventListener("keypress", function(e){
            if(e.key==="Enter") {
              e.preventDefault();
              el.click(); 
            }
          })  
        }
      )
    }
  }

  Drupal.behaviors.header_main_menu = {

    attach(context) {
      once('header-nav', '.region-header .header-navbar__menu_container', context)
        .forEach(el => {
          let toggleMenus = el.querySelectorAll('.header_main_menu');
          toggleMenus.forEach( (menu, idx) => {
            if(menu.querySelector('.is-active')){
              menu.classList.add('active-trail')
            }
            let toggle = menu.querySelector('.toggle');
            let child = menu.querySelector('.child');
            child.setAttribute('id', 'header-menu_'+idx);
            toggle.setAttribute('aria-controls', 'header-menu_'+idx);
            // todo abstract toggle function
            toggle.addEventListener('click', function(e) {
              e.preventDefault()
              if(!child.classList.contains('active')){
                el.querySelectorAll('.header_main_menu .child').forEach(childMenu => {
                  if(childMenu.classList.contains('active')){
                    childMenu.classList.toggle('active'); 
                    toggleOpen(toggle);
                  }
                });
              }
              child.classList.toggle('active');
              toggleOpen(toggle);
             }, false);
          })
        });
    },
  };

  function toggleOpen(element) {
    element.getAttribute('aria-expanded') === 'true'
      ? element.setAttribute('aria-expanded', 'false')
      : element.setAttribute('aria-expanded', 'true')
  }
})(Drupal, once);
